import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import ReadyToDisposeList from './ReadyToDisposeList'
import ReadyToDisposeEdit from './ReadyToDisposeEdit';

// The list is a read-only SQL view (`view_disposals`) and the service exposes
// no PUT for /readydisposing. The edit screen is still registered, but it
// writes through the `shipments` resource instead - see the comment in
// ReadyToDisposeEdit.js. Do not remove that resource override or saves will
// silently no-op again.
export default {
    list: ReadyToDisposeList,
    icon: DeleteSweepIcon,
    edit: ReadyToDisposeEdit
};
